import { brandPrimary } from '../../../styles/colors';
import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	card: {
		border: THEME.common.border,
		borderRadius: THEME.common.borderRadius,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		marginBottom: THEME.spacing.lg,
		marginTop: THEME.spacing.lg,
		overflow: 'hidden',
	},
	container: {
		display: 'flex',
		flexDirection: 'column',
	},
	copyKeyButton: {
		color: brandPrimary,
		fontSize: 16,
		marginLeft: 24,
	},
	header: {
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: THEME.spacing.xl,
	},
	headerActions: {
		padding: 16,
	},
});
